import { useEffect, useState } from "react";
import { SaveTypeCatalog } from "./TypeCatalogService";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIndexLogic } from "./index-logic";
import { useInventoryPermission } from "../permissions/InventoryPermissions";

export const useAddAssetTypeLogic = ({ handleClose, setLoading, open, selectedAssetType }) => {
  //#region Permissions
  const { InventoryPermissionProps } = useInventoryPermission();
  const {
    hasTypeCatalogSavePermission,
  } = InventoryPermissionProps;
  //#endregion Permissions

  const { IndexProps } = useIndexLogic();
  const { loadData } = IndexProps;
  // Form state
  const [assetTypeForm, setAssetTypeForm] = useState({
    typeCatalogID: 0,
    entityType: "Asset",
    typeName: "",
    description: "",
    name: "", // The API schema includes this but it might be redundant with typeName
    isVehicle: false,
    isActive: true
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      if (selectedAssetType) {
        setAssetTypeForm({
          ...selectedAssetType
        });
      } else {
        // Reset for a new asset type
        resetForm();
      }
    }
  }, [open, selectedAssetType]);

  // Form change handlers
  const handleInputChange = (e) => {
    
    if(!hasTypeCatalogSavePermission) return;

    const { name, value, checked } = e.target;
    setAssetTypeForm({
      ...assetTypeForm,
      [name]: name === 'isVehicle' ? checked : value
    });
    
    // Clear error for this field if any
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    
    if (!assetTypeForm.typeName.trim()) {
      newErrors.typeName = "Asset Type name is required";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Save asset type
  const handleSaveAssetType = async () => {
    if(!hasTypeCatalogSavePermission) return;

    try {
      if (!validateForm()) {
        return false;
      }
      
      const formData = {
        ...assetTypeForm,
        name: assetTypeForm.name || assetTypeForm.typeName
      };
      
      const response = await SaveTypeCatalog(formData);
      
      if (!response.isError) {
        handleClose();

          loadData(); 
          toast.success(assetTypeForm.typeCatalogID ? "Asset type updated successfully" : "Asset type created successfully", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
        
        return true;
      } else {
        toast.error(response.message || "Failed to save asset type", {
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
        console.error("Error saving asset type:", response.message);
        return false;
      }
    } catch (error) {
      toast.error("An error occurred while saving the asset type", {
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
      console.error("Error saving asset type:", error);
      return false;
    } finally {
    }
  };

  const resetForm = () => {
    if(!hasTypeCatalogSavePermission) return;

    setAssetTypeForm({
      typeCatalogID: 0,
      entityType: "Asset",
      typeName: "",
      description: "",
      name: "",
      isActive: true
    });
    setErrors({});
  };

  return {
    assetTypeForm,
    errors,
    handleInputChange,
    handleSaveAssetType,
    resetForm
  };
}; 